import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {
  SandyAssetModel,
  SandyImportDataModel,
  SandyLineItemModel,
  SandyPreImportDataModel,
  sandyPreImportDataModelFactory,
} from "./sandy-import-data.model";

export interface SandyBreadcrumbItemModel {
  text: string;
  queryAction: string;
  queryParams: {[key: string]: string};
}

export function sandyBreadcrumbItemModelFactory(json?: any): SandyBreadcrumbItemModel[] {
  return Array.from(json || []).map((it: any) => ({
    text: it.text || "",
    queryAction: it.queryAction || "",
    queryParams: it.queryParams || {},
  } as SandyBreadcrumbItemModel));
}

@Injectable()
export class SandyService {
  private url: string = "/api/oss-sandy";

  constructor(private http: HttpClient) {}

  getPreImportStatus(params: {[key: string]: string}): Promise<SandyPreImportDataModel> {
    return this.http.get<SandyPreImportDataModel>(`${this.url}/pre-import-status`, {params})
      .pipe(map(sandyPreImportDataModelFactory))
      .toPromise();
  }

  getSandyBreadcrumbs(entityId, entityParam): Promise<SandyBreadcrumbItemModel[]> {
    const params = {[entityParam]: entityId};
    return this.http.get(`${this.url}/sandy-breadcrumbs`, {params})
      .pipe(map(sandyBreadcrumbItemModelFactory))
      .toPromise();
  }

  fetch(params: {[key: string]: string}): Promise<SandyImportDataModel> {
    return this.http.get<SandyImportDataModel>(`${this.url}/fetch`, {params})
      .pipe(map(json => new SandyImportDataModel(json)))
      .toPromise();
  }

  save(assets: SandyAssetModel[], sandyItems: SandyLineItemModel[], params: {[key: string]: string}):
    Promise<SandyPreImportDataModel> {
    return this.http.post<{success: boolean}>(`${this.url}/save`, {...params, assets, sandyItems})
      .pipe(map(sandyPreImportDataModelFactory))
      .toPromise();
  }
}
